<template>
  <div>
    <Header :url="url"></Header>
    <van-swipe :autoplay="3000" style="margin-top:1rem">
      <van-swipe-item v-for="(image, index) in images" @click="tolink(image)" :key="index">
        <img class="banner" :src="image.posterImg" alt />
      </van-swipe-item>
    </van-swipe>
    <div>
      <van-tabs
        style="padding: 0 0.4rem 0 0.3rem"
        :animated="true"
        :ellipsis='false'
        swipe-threshold='5'
        v-model="active"
        @change="tabChange"
        color="#1363F7"
        title-active-color="#1363F7"
      >
        <van-tab v-for="(i) in list" :key="i.id" :title="i.name">
          <van-pull-refresh :style="{minHeight: `${windowHeight - 150}px`}" v-model="isLoading" @refresh="onRefresh">
            <van-list
        :immediate-check="false"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
          <div class="list-item" @click="toDetail(item.id)" v-for="(item,key) in listData" :key="key">
            <div class="img">
              <!-- 正式 -->

              <img :src="item.img" alt="">
              <!-- 测试 -->
              <!-- <img :src="'http://www.ost.com/templates/calmlog/'+item.thumbnail"> -->
            </div>
            <div class="list-item-r">
              <div class="list-item-title">{{item.title}}</div>
              <div v-if="item.description" class="list-item-content">{{item.description}}</div>
              <div class="list-item-foot">
              <!-- <div>作者: {{item.author}}</div> -->
              <div>发布时间: {{item.releaseTime}}</div>
              <!-- <div style="display:flex">
                <img class="liulan" src="/static/img/icon/liulan.png" alt="">
                <div>{{item.view_count}}</div>
              </div> -->
            </div>
            </div>
          </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
    <div v-if="scrollTop" @click="scrollToTop" class="to-top">
      <img src="/static/img/icon/toTop.png" alt />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { getVatList, getVat } from '@/api/VAT'
import { getSysPosterConfigList, adRecordBanner } from '@/api/land.js'
import { throttle } from '@/util/util'
export default {
  data () {
    return {
      url: '/VAT',
      active: 0,
      list: [],
      pageSize: 10,
      pageNum: 0,
      listData: [],
      images: [],
      isLoading: false,
      windowHeight: '',
      id: '',
      loading: false,
      finished: false,
      scrollTop: false
    }
  },
  components: { Header },
  created () {
    // let phone = navigator.userAgent;//设备机型的相关信息
    // phone = phone.substring(phone.indexOf('(')+1,phone.indexOf(';'));//处理信息，输出iphone
    // console.log(phone,'设备型号--------------')
    // if (phone.indexOf('Windows') != -1) {
    //   window.location.href='https://www.ippmaster.com/'
    // }
    document.title = '资讯百科-麦德通'
    document.documentElement.scrollTop = 0
    this.windowHeight = document.documentElement.clientHeight
    getVatList(3).then(res => {
      let a = {
        name: '全部',
        id: ''
      }
      res.data.titleList.unshift(a)
      this.list = res.data.titleList
      if (this.$route.query.active) {
        this.active = Number(this.$route.query.active) + 1
        this.id = this.list[this.active].id
        this.getVat(this.id)
      } else {
        this.getVat('')
      }
    })
    this.getImgList()
  },
  watch: {
    '$route.query' (newVal, oldVal) {
      let { active } = newVal || {}
      this.active = Number(active) + 1
      this.id = this.list[this.active].id
      this.getVat(this.id)
    }
  },
  methods: {
    /**
     * @description 一键回到顶部
     */
    scrollToTop () {
      setTimeout(() => {
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }, 300)
    },
    getImgList () {
      getSysPosterConfigList({ module: 2, status: 1, showPageNames: 'guide' })
        .then(res => {
          if (res.code == 0) {
            if (res.data && res.data.length > 0) {
              res.data.sort(function (a, b) {
                return a.sort - b.sort
              })
              let list = []
              res.data.forEach(i => {
                list.push({
                  posterId: i.posterId,
                  incrViewCount: 1
                })
              })
              adRecordBanner(list).then()
              this.images = res.data
            }
          } else {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          }
        })
        .catch(() => {
          // this.$toast({ message: '系统繁忙，请稍后重试' })
        })
    },
    tolink (e) {
      if (e.showType == '1') {
        adRecordBanner([{ posterId: e.posterId, incrClickCount: 1 }]).then()
        let href = e.showWay
        if (href.indexOf('http') != -1 || href.indexOf('https') != -1) {
          window.open(e.showWay, '_blank')
        } else {
          if (
            this.phoneInfo.indexOf('Windows') != -1 ||
            this.phoneInfo.indexOf('Macintosh') != -1
          ) {
            this.$toast({ message: '请用手机端打开' })
          } else {
            linkToProgram({ path: href })
              .then(res => {
                if (res.code == 0) {
                  window.location.href = res.data
                } else {
                  this.$toast({ message: '系统繁忙，请稍后重试' })
                }
              })
              .catch(() => {
                this.$toast({ message: '系统繁忙，请稍后重试' })
              })
          }
        }
      }
    },
    /**
     * @description 切换
     */
    tabChange (e) {
      document.title = '百科-麦德通'
      this.pageNum = 0
      this.id = this.list[e].id
      this.$store.state.vatActive = e
      this.getVat(this.id)
    },
    /**
     * @description 下拉刷新
     */
    onRefresh () {
      this.isLoading = true
      this.getVat(this.id)
    },
    /**
     * @description 上拉加载
     */
    onLoad () {
      this.pageNum++
      this.loading = true
      getVat({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        type: 1,
        categoryId: this.id
      }).then(res => {
        if (res.code == 0) {
          if (this.pageNum == 1) {
            this.listData = []
            this.listData = res.rows
          } else {
            this.listData = this.listData.concat(res.rows)
          }
          this.loading = false
          if (res.rows.length < 10) {
            this.finished = true
          }
        }
        this.isLoading = false
      })
    },
    /**
     * @description 去详情页
     */
    toDetail (e) {
      this.id = e
      let activeId = this.list[this.active].id
      this.$router.push({
        name: 'vatDetail',
        query: {
          id: e,
          active: this.active
        }
      })
    },
    getVat (id) {
      this.pageNum = 1
      this.finished = false
      this.loading = false
      getVat({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        type: 1,
        categoryId: id
      }).then(res => {
        if (res.code == 0) {
          this.listData = res.rows
        }
        this.isLoading = false
      })
    },
    handleScroll: throttle(function () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      console.log(scrollTop)
      if (scrollTop > 500) {
        this.scrollTop = true
      } else {
        this.scrollTop = false
      }
    }, 500)
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  }
}
</script>

<style scoped>
.list-item {
  border-top: 0.2px solid lightgray;
  padding: 0.3rem 0 0.3rem 0;
  display: flex;
  /* justify-content: space-between; */
}
.img {
  width: 40%;
  height: 1.5rem;
  border-radius: .04rem;
}
.img img {
  width: 100%;
  height: 100%;
}
.banner {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.list-item-r {
  width: 60%;
  text-align: left;
  margin-left: 0.15rem;
}
.list-item-title {
  font-size: 0.26rem;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.to-top {
  position: fixed;
  width: 1rem !important;
  right:5px;
  top: 80% !important;
  height: 1rem !important;
  display: inline-block;
  border-radius: 100%;
  background: white;
  box-shadow: 10px 10px 70px gray;
}
.to-top img {
  width: 100%;
}
.list-item-content {
  font-size: 0.22rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-top:0.15rem
}
.list-item-foot{
  display: flex;
  font-size: 0.17rem;
  justify-content: space-between;
  margin-top: 0.13rem;
}
.content-no{
  opacity: 0;
}
.liulan{
  display: inline-block;
  width: 0.2rem;
  height: 0.15rem;
  margin:  0.02rem 0.05rem 0 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Vat/VAT.vue